export default __webpack_public_path__ + "static/media/BG new 2.deea3775.png";